import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-energy-providers-tdu-rates-modal',
  templateUrl: './energy-providers-tdu-rates-modal.component.html',
  styleUrls: ['./energy-providers-tdu-rates-modal.component.css'],
})
export class EnergyProvidersTduRatesModalComponent implements OnInit {
  tduRatesForm = this.fb.group({
    abbreviation: [, Validators.required],
    code: [, Validators.required],
    istaId: [, Validators.required],
    moveInFee: [, Validators.required],
    priorityMoveInFee: [, Validators.required],
    switchFee: [, Validators.required],
    typeOfTDU: [, Validators.required],
    tDU_Charges_Month: [, Validators.required],
    tDU_Charges_Kwh: [, Validators.required],
    daily_Charge: [, Validators.required],
    energy_Price: [, Validators.required],
    five_hundred: [, Validators.required],
    thousand: [, Validators.required],
    two_thousand: [, Validators.required],
  });
  fromPage: any;
  fromDialog: string;
  action: any;
  itemData: any;
  constructor(
    private fb: FormBuilder,
    private residentialService: ResidentialService, // public dialogRef: MatDialogRef<EnergyProvidersModalComponent>, // @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<EnergyProvidersTduRatesModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fromPage = data.pageValue;
    this.action = data.action;
    this.itemData = data.itemData;
  }

  ngOnInit() {
    console.log('parent', this.fromPage);
    if (this.action == 'Update') {
      const postobj = this.setModulesInfo();
      this.tduRatesForm.patchValue({
        // {ModuleID: "1", ModuleName: "ACH Credit FY"}
        abbreviation: this.itemData['Abbreviation'],
        code: this.itemData['Code'],
        istaId: this.itemData['IstaId'],
        moveInFee: this.itemData['MoveInFee'],
        priorityMoveInFee: this.itemData['PriorityMoveInFee'],
        switchFee: this.itemData['SwitchFee'],
        typeOfTDU: this.itemData['TypeOfTDU'],
        tDU_Charges_Month: this.itemData['TDU_Charges_Month'],
        tDU_Charges_Kwh: this.itemData['TDU_Charges_Kwh'],
        daily_Charge: this.itemData['Daily_Charge'],
        energy_Price: this.itemData['Energy_Price'],
        five_hundred: this.itemData['Five_Hundred'],
        thousand: this.itemData['Thousand'],
        two_thousand: this.itemData['Two_Thousand'],
      });
    }
  }
  setModulesInfo() {
    let abbreviation = this.tduRatesForm.get('abbreviation').value;
    let code = this.tduRatesForm.get('code').value;
    let istaId = this.tduRatesForm.get('istaId').value;
    let moveInFee = this.tduRatesForm.get('moveInFee').value;
    let priorityMoveInFee = this.tduRatesForm.get('priorityMoveInFee').value;
    let switchFee = this.tduRatesForm.get('switchFee').value;
    let typeOfTDU = this.tduRatesForm.get('typeOfTDU').value;
    let tDU_Charges_Month = this.tduRatesForm.get('tDU_Charges_Month').value;
    let tDU_Charges_Kwh = this.tduRatesForm.get('tDU_Charges_Kwh').value;
    let five_hundred = this.tduRatesForm.get('five_hundred').value;
    let daily_Charge = this.tduRatesForm.get('daily_Charge').value;
    let energy_Price = this.tduRatesForm.get('energy_Price').value;
    let thousand = this.tduRatesForm.get('thousand').value;
    let two_thousand = this.tduRatesForm.get('two_thousand').value;

    let postobj = {
      Abbreviation: abbreviation,
      Code: code,
      IstaId: istaId,
      MoveInFee: moveInFee,
      PriorityMoveInFee: priorityMoveInFee,
      SwitchFee: switchFee,
      TypeOfTDU: typeOfTDU,
      TDU_Charges_Month: tDU_Charges_Month,
      TDU_Charges_Kwh: tDU_Charges_Kwh,
      Daily_Charge: daily_Charge,
      Energy_Price: energy_Price,
      Five_Hundred: five_hundred,
      Thousand: thousand,
      Two_Thousand: two_thousand,
    };
    return postobj;
  }
  postDataOfNewEnergyProvider() {
    const postobj = this.setModulesInfo();
    if (this.action == 'Update') {
      this.updateProvider(postobj);
    } else {
      this.createProvider(postobj);
    }
  }
  updateProvider(postobj) {
    let rowIndex = this.fromPage.findIndex(
      (element) =>
        element['ProviderName'] == this.itemData['ProviderName'] &&
        element['UtilityName'] == this.itemData['UtilityName']
    );
    this.residentialService
      .postDataOfNewEnergyProviderTDURates(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        if (rowIndex) {
          this.fromPage[rowIndex] = JSON.parse(JSON.stringify(postobj));
        }
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  createProvider(postobj) {
    this.residentialService
      .postDataOfNewEnergyProviderTDURates(postobj)
      .subscribe((response: any) => {
        console.log('postreports', response);
        // this.fromPage = [...this.fromPage];
        this.dialogRef.close({ event: this.action, data: this.fromPage });
      });
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
}
